import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectHasFiber } from '../../../../../redux';
import DeskLaptop from '../../../assets/DeskLaptop';

import styles from './styles.module.scss';

type NoPlansAvailableProps = {
  handleGoBack: (e: React.MouseEvent<HTMLElement>) => void;
};

const NoPlansAvailable = ({ handleGoBack }: NoPlansAvailableProps) => {
  const { t } = useTranslation('ChangePlan');
  const isFiber = useSelector(selectHasFiber);

  return (
    <Surface
      variant="secondary"
      className={styles['noPlansPage']}
      py={{ xs: '96px', md: undefined }}
      px={{ xs: '16px', md: '32px' }}
    >
      <DeskLaptop data-cy="change-plan-page-error-svg" />

      <div>
        <Txt data-cy="no-plans-available-page-title" variant="heading4" mb="12px">
          {t('noPlansAvailablePage.title')}
        </Txt>
        <Txt data-cy="no-plans-available-page-description" component="p" variant="bodyLargeRegular" color="subtle">
          {isFiber ? t('noPlansAvailablePage.description.fiber') : t('noPlansAvailablePage.description.satellite')}
        </Txt>
      </div>

      <div className={styles['button']}>
        <Button fluid data-cy="no-plans-available-go-back" variant="primary" onClick={handleGoBack}>
          {t('goBack')}
        </Button>
      </div>
    </Surface>
  );
};

export default NoPlansAvailable;
